export default {
  data() {
    return {
      cardList: [
        {
          id: 1,
          no: 87,
          name: "あきの",
          yomi: "あきの",
          yomiRoman1: "akino",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 2,
          no: 32,
          name: "はるす",
          yomi: "はるす",
          yomiRoman1: "harusu",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 3,
          no: 92,
          name: "あし",
          yomi: "あし",
          yomiRoman1: "asi",
          yomiRoman2: "ashi",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 4,
          no: 53,
          name: "たご",
          yomi: "たご",
          yomiRoman1: "tago",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 5,
          no: 66,
          name: "おく",
          yomi: "おく",
          yomiRoman1: "oku",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 6,
          no: 43,
          name: "かさ",
          yomi: "かさ",
          yomiRoman1: "kasa",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 7,
          no: 94,
          name: "あまの",
          yomi: "あまの",
          yomiRoman1: "amano",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 8,
          no: 70,
          name: "わがい",
          yomi: "わがい",
          yomiRoman1: "wagai",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 9,
          no: 31,
          name: "はなの",
          yomi: "はなの",
          yomiRoman1: "hanano",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 10,
          no: 62,
          name: "これ",
          yomi: "これ",
          yomiRoman1: "kore",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 11,
          no: 75,
          name: "わた・や",
          yomi: "わたのはらや",
          yomiRoman1: "watanoharaya",
          kimariji: "6",
          isActive: false,
          isMarking: false,
        },
        {
          id: 12,
          no: 93,
          name: "あまつ",
          yomi: "あまつ",
          yomiRoman1: "amatu",
          yomiRoman2: "amatsu",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 13,
          no: 11,
          name: "つく",
          yomi: "つく",
          yomiRoman1: "tuku",
          yomiRoman2: "tsuku",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 14,
          no: 49,
          name: "みち",
          yomi: "みち",
          yomiRoman1: "miti",
          yomiRoman2: "michi",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 15,
          no: 28,
          name: "きみ・は",
          yomi: "きみがためは",
          yomiRoman1: "kimigatameha",
          kimariji: "6",
          isActive: false,
          isMarking: false,
        },
        {
          id: 16,
          no: 55,
          name: "たち",
          yomi: "たち",
          yomiRoman1: "tati",
          yomiRoman2: "tachi",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 17,
          no: 23,
          name: "ちは",
          yomi: "ちは",
          yomiRoman1: "tiha",
          yomiRoman2: "chiha",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 18,
          no: 2,
          name: "す",
          yomi: "す",
          yomiRoman1: "su",
          yomiRoman2: "su",
          kimariji: "1",
          isActive: false,
          isMarking: false,
        },
        {
          id: 19,
          no: 84,
          name: "なにわが",
          nameOld: "なにはが",
          yomi: "なにわが",
          yomiOld: "なにはが",
          yomiRoman1: "naniwaga",
          kimariji: "4",
          isActive: false,
          isMarking: false,
        },
        {
          id: 20,
          no: 76,
          name: "わび",
          yomi: "わび",
          yomiRoman1: "wabi",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 21,
          no: 19,
          name: "いまこ",
          yomi: "いまこ",
          yomiRoman1: "imako",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 22,
          no: 4,
          name: "ふ",
          yomi: "ふ",
          yomiRoman1: "hu",
          yomiRoman2: "fu",
          kimariji: "1",
          isActive: false,
          isMarking: false,
        },
        {
          id: 23,
          no: 10,
          name: "つき",
          yomi: "つき",
          yomiRoman1: "tuki",
          yomiRoman2: "tsuki",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 24,
          no: 61,
          name: "この",
          yomi: "この",
          yomiRoman1: "kono",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 25,
          no: 82,
          name: "なにし",
          yomi: "なにし",
          yomiRoman1: "nanisi",
          yomiRoman2: "nanishi",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 26,
          no: 67,
          name: "おぐ",
          nameOld: "をぐ",
          yomi: "おぐ",
          yomiOld: "をぐ",
          yomiRoman1: "ogu",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 27,
          no: 47,
          name: "みかの",
          yomi: "みかの",
          yomiRoman1: "mikano",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 28,
          no: 37,
          name: "やまざ",
          yomi: "やまざ",
          yomiRoman1: "yamaza",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 29,
          no: 58,
          name: "こころあ",
          yomi: "こころあ",
          yomiRoman1: "kokoroa",
          kimariji: "4",
          isActive: false,
          isMarking: false,
        },
        {
          id: 30,
          no: 97,
          name: "ありあ",
          yomi: "ありあ",
          yomiRoman1: "aria",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 31,
          no: 90,
          name: "あさぼ・あ",
          yomi: "あさぼらけあ",
          yomiRoman1: "asaborakea",
          kimariji: "6",
          isActive: false,
          isMarking: false,
        },
        {
          id: 32,
          no: 36,
          name: "やまが",
          yomi: "やまが",
          yomiRoman1: "yamaga",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 33,
          no: 24,
          name: "ひさ",
          yomi: "ひさ",
          yomiRoman1: "hisa",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 34,
          no: 56,
          name: "たれ",
          yomi: "たれ",
          yomiRoman1: "tare",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 35,
          no: 25,
          name: "ひとは",
          yomi: "ひとは",
          yomiRoman1: "hitowa",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 36,
          no: 81,
          name: "なつ",
          yomi: "なつ",
          yomiRoman1: "natu",
          yomiRoman2: "natsu",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 37,
          no: 13,
          name: "しら",
          yomi: "しら",
          yomiRoman1: "sira",
          yomiRoman2: "shira",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 38,
          no: 72,
          name: "わすら",
          yomi: "わすら",
          yomiRoman1: "wasura",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 39,
          no: 89,
          name: "あさじ",
          nameOld: "あさぢ",
          yomi: "あさじ",
          yomiOld: "あさぢ",
          yomiRoman1: "asazi",
          yomiRoman2: "asaji",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 40,
          no: 12,
          name: "しの",
          yomi: "しの",
          yomiRoman1: "sino",
          yomiRoman2: "shino",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 41,
          no: 57,
          name: "こい",
          nameOld: "こひ",
          yomi: "こい",
          yomiOld: "こひ",
          yomiRoman1: "koi",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 42,
          no: 22,
          name: "ちぎりき",
          yomi: "ちぎりき",
          yomiRoman1: "tigiriki",
          yomiRoman2: "chigiriki",
          kimariji: "4",
          isActive: false,
          isMarking: false,
        },
        {
          id: 43,
          no: 85,
          name: "あい",
          nameOld: "あひ",
          yomi: "あい",
          yomiOld: "あひ",
          yomiRoman1: "ai",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 44,
          no: 65,
          name: "おおこ",
          nameOld: "あふこ",
          yomi: "おおこ",
          yomiOld: "あふこ",
          yomiRoman1: "ooko",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 45,
          no: 100,
          name: "あわれ",
          nameOld: "あはれ",
          yomi: "あわれ",
          yomiOld: "あはれ",
          yomiRoman1: "aware",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 46,
          no: 17,
          name: "ゆら",
          yomi: "ゆら",
          yomiRoman1: "yura",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 47,
          no: 34,
          name: "やえ",
          nameOld: "やへ",
          yomi: "やえ",
          yomiOld: "やへ",
          yomiRoman1: "yae",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 48,
          no: 45,
          name: "かぜを",
          yomi: "かぜを",
          yomiRoman1: "kazeo",
          yomiRoman2: "kazewo",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 49,
          no: 46,
          name: "みかき",
          yomi: "みかき",
          yomiRoman1: "mikaki",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 50,
          no: 27,
          name: "きみ・お",
          nameOld: "きみ・を",
          yomi: "きみがためお",
          yomiOld: "きみがためを",
          yomiRoman1: "kimigatameo",
          kimariji: "6",
          isActive: false,
          isMarking: false,
        },
        {
          id: 51,
          no: 42,
          name: "かく",
          yomi: "かく",
          yomiRoman1: "kaku",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 52,
          no: 88,
          name: "あけ",
          yomi: "あけ",
          yomiRoman1: "ake",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 53,
          no: 79,
          name: "なげき",
          yomi: "なげき",
          yomiRoman1: "nageki",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 54,
          no: 73,
          name: "わすれ",
          yomi: "わすれ",
          yomiRoman1: "wasure",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 55,
          no: 52,
          name: "たき",
          yomi: "たき",
          yomiRoman1: "taki",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 56,
          no: 95,
          name: "あらざ",
          yomi: "あらざ",
          yomiRoman1: "araza",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 57,
          no: 3,
          name: "め",
          yomi: "め",
          yomiRoman1: "me",
          kimariji: "1",
          isActive: false,
          isMarking: false,
        },
        {
          id: 58,
          no: 98,
          name: "ありま",
          yomi: "ありま",
          yomiRoman1: "arima",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 59,
          no: 35,
          name: "やす",
          yomi: "やす",
          yomiRoman1: "yasu",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 60,
          no: 63,
          name: "おおえ",
          nameOld: "おほえ",
          yomi: "おおえ",
          yomiOld: "おほえ",
          yomiRoman1: "ooe",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 61,
          no: 18,
          name: "いに",
          yomi: "いに",
          yomiRoman1: "ini",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 62,
          no: 41,
          name: "よを",
          yomi: "よを",
          yomiRoman1: "yoo",
          yomiRoman2: "yowo",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 63,
          no: 20,
          name: "いまは",
          yomi: "いまは",
          yomiRoman1: "imawa",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 64,
          no: 91,
          name: "あさぼ・う",
          yomi: "あさぼらけう",
          yomiRoman1: "asaborakeu",
          kimariji: "6",
          isActive: false,
          isMarking: false,
        },
        {
          id: 65,
          no: 9,
          name: "うら",
          yomi: "うら",
          yomiRoman1: "ura",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 66,
          no: 15,
          name: "もろ",
          yomi: "もろ",
          yomiRoman1: "moro",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 67,
          no: 33,
          name: "はるの",
          yomi: "はるの",
          yomiRoman1: "haruno",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 68,
          no: 59,
          name: "こころに",
          yomi: "こころに",
          yomiRoman1: "kokoroni",
          kimariji: "4",
          isActive: false,
          isMarking: false,
        },
        {
          id: 69,
          no: 96,
          name: "あらし",
          yomi: "あらし",
          yomiRoman1: "arasi",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 70,
          no: 5,
          name: "さ",
          yomi: "さ",
          yomiRoman1: "sa",
          kimariji: "1",
          isActive: false,
          isMarking: false,
        },
        {
          id: 71,
          no: 16,
          name: "ゆう",
          nameOld: "ゆふ",
          yomi: "ゆう",
          yomiOld: "ゆふ",
          yomiRoman1: "yuu",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 72,
          no: 68,
          name: "おと",
          yomi: "おと",
          yomiRoman1: "oto",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 73,
          no: 51,
          name: "たか",
          yomi: "たか",
          yomiRoman1: "taka",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 74,
          no: 8,
          name: "うか",
          yomi: "うか",
          yomiRoman1: "uka",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 75,
          no: 21,
          name: "ちぎりお",
          yomi: "ちぎりお",
          yomiRoman1: "tigirio",
          yomiRoman2: "chigirio",
          kimariji: "4",
          isActive: false,
          isMarking: false,
        },
        {
          id: 76,
          no: 74,
          name: "わた・こ",
          yomi: "わたのはらこ",
          yomiRoman1: "watanoharako",
          kimariji: "6",
          isActive: false,
          isMarking: false,
        },
        {
          id: 77,
          no: 7,
          name: "せ",
          yomi: "せ",
          yomiRoman1: "se",
          kimariji: "1",
          isActive: false,
          isMarking: false,
        },
        {
          id: 78,
          no: 99,
          name: "あわじ",
          nameOld: "あはぢ",
          yomi: "あわじ",
          yomiOld: "あはぢ",
          yomiRoman1: "awazi",
          yomiRoman2: "awaji",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 79,
          no: 86,
          name: "あきか",
          yomi: "あきか",
          yomiRoman1: "akika",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 80,
          no: 77,
          name: "ながか",
          yomi: "ながか",
          yomiRoman1: "nagaka",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 81,
          no: 6,
          name: "ほ",
          yomi: "ほ",
          yomiRoman1: "ho",
          kimariji: "1",
          isActive: false,
          isMarking: false,
        },
        {
          id: 82,
          no: 69,
          name: "おも",
          yomi: "おも",
          yomiRoman1: "omo",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 83,
          no: 39,
          name: "よの・よ",
          yomi: "よのなかよ",
          yomiRoman1: "yononakayo",
          kimariji: "5",
          isActive: false,
          isMarking: false,
        },
        {
          id: 84,
          no: 78,
          name: "ながら",
          yomi: "ながら",
          yomiRoman1: "nagara",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 85,
          no: 40,
          name: "よも",
          yomi: "よも",
          yomiRoman1: "yomo",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 86,
          no: 80,
          name: "なげけ",
          yomi: "なげけ",
          yomiRoman1: "nageke",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 87,
          no: 1,
          name: "む",
          yomi: "む",
          yomiRoman1: "mu",
          kimariji: "1",
          isActive: false,
          isMarking: false,
        },
        {
          id: 88,
          no: 83,
          name: "なにわえ",
          nameOld: "なにはえ",
          yomi: "なにわえ",
          yomiOld: "なにはえ",
          yomiRoman1: "naniwae",
          kimariji: "4",
          isActive: false,
          isMarking: false,
        },
        {
          id: 89,
          no: 54,
          name: "たま",
          yomi: "たま",
          yomiRoman1: "tama",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 90,
          no: 48,
          name: "みせ",
          yomi: "みせ",
          yomiRoman1: "mise",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 91,
          no: 29,
          name: "きり",
          yomi: "きり",
          yomiRoman1: "kiri",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 92,
          no: 71,
          name: "わがそ",
          yomi: "わがそ",
          yomiRoman1: "wagaso",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 93,
          no: 38,
          name: "よの・は",
          yomi: "よのなかは",
          yomiRoman1: "yononakawa",
          kimariji: "5",
          isActive: false,
          isMarking: false,
        },
        {
          id: 94,
          no: 50,
          name: "みよ",
          yomi: "みよ",
          yomiRoman1: "miyo",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 95,
          no: 64,
          name: "おおけ",
          nameOld: "おほけ",
          yomi: "おおけ",
          yomiOld: "おほけ",
          yomiRoman1: "ooke",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 96,
          no: 30,
          name: "はなさ",
          yomi: "はなさ",
          yomiRoman1: "hanasa",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 97,
          no: 60,
          name: "こぬ",
          yomi: "こぬ",
          yomiRoman1: "konu",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
        {
          id: 98,
          no: 44,
          name: "かぜそ",
          yomi: "かぜそ",
          yomiRoman1: "kazeso",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 99,
          no: 26,
          name: "ひとも",
          yomi: "ひとも",
          yomiRoman1: "hitomo",
          kimariji: "3",
          isActive: false,
          isMarking: false,
        },
        {
          id: 100,
          no: 14,
          name: "もも",
          yomi: "もも",
          yomiRoman1: "momo",
          kimariji: "2",
          isActive: false,
          isMarking: false,
        },
      ],
    };
  },
};
